import React from "react";
import axios from 'axios';
import '../auth.css';
import '../list.css';
import { Button } from 'semantic-ui-react'
import {reactLocalStorage} from 'reactjs-localstorage';
import Select from "react-select";
import i18n from '../i18n';
import {connect} from 'react-redux';
import Menutest from './menu.js';
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBCard, MDBCardBody } from 'mdbreact';
import { Input ,TextArea} from 'semantic-ui-react'
import { API_BASE_URL } from "../utils/endpoints";

const data = new FormData();
var typeOptions=[]
class EditPromotion extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            type: [
                { label: "Bulk SMS", value: "bulk" },
                { label: "Profiled SMS", value: "profiled" },
                { label: "LBA SMS", value: "lba" },
                { label: "Survey SMS", value: "survey" },
                { label: "International SMS", value: "international" },
            ],
   
            typeselect:'',
            uploadfile:[],
            description:'',
            isArabic:false
        }
  
    }
    componentWillMount(){
        var type=reactLocalStorage.get('id_user_edit_promotion_type')
        var description=reactLocalStorage.get('id_user_edit_promotion_description')
        var image=reactLocalStorage.get('id_user_edit_sender_name_adv');
        var id=reactLocalStorage.get('id_user_edit_promotion');
        this.setState({type:type})
        this.setState({description:description})
        this.setState({id:id})
        this.setState({image:image})

        // to get available type of balance

        var token=reactLocalStorage.get('accessToken');
        var ip=API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if(ip.includes(s2))
        {
         apiBaseUrl =API_BASE_URL + "/core/user/rest/senderid/getSenderIds";
         }
        else
        {
         apiBaseUrl = API_BASE_URL+"/core/user/rest/senderid/getSenderIds";  
        }
     
     
        
       
        var headers = {'Content-Type': 'application/json', 'token' :token }
     axios.get(apiBaseUrl,{headers: headers})
         .then(res => {
      
     
           if(res.data.result.sender_ids != undefined)
             {
               const senderidoption=res.data.result.sender_ids;
               var length=res.data.result.sender_ids.length;
               var i;
               const newArr = this.state.options_sender;
               for(i=0;i<length;i++)
               {
                var value_option=senderidoption[i].sender_id;
  
                newArr.push({
                   label: value_option, 
                   value:senderidoption[i].id
               });
                 
               }
               this.setState({options_sender: res.data.result.sender_ids})
  
              
  
            
               
               typeOptions= newArr;
            }
          
          })
    }
    onChange = values => {
        this.setState({typeselect:values.value});
        
    }

    handleChange = event => {
        event.preventDefault();
        const newArr = this.state.uploadfile;
        newArr.push(event.target.files[0]);
        this.setState({
            uploadfile: newArr
        })
    

        data.append('file', event.target.files[0]);
   



  
    }
    changeDescription=event=>{
        this.setState({description:event.target.value})
    }
    handleSubmit=event=>{
        event.preventDefault();
        var test= new Blob([JSON.stringify({  
        "description":this.state.description,
        "type":this.state.typeselect,
    }
        )] ,{type : "application/json"});
        data.append('object', test);
        var token=reactLocalStorage.get('accessToken');
        var ip=API_BASE_URL;
        var s2 = "localhost:3000";
        var apiBaseUrl;
        if(ip.includes(s2))
        {
         apiBaseUrl =API_BASE_URL + "/core/corpsms/sendBulk";
         }
        else
        {
         apiBaseUrl = API_BASE_URL+"/core/corpsms/sendBulk";  
        }
    
    
    
            axios.post(apiBaseUrl,data,{headers: {   'Content-Type': 'multipart/form-data',
            'token':token}}).then(function (response)
            {
      
            if(response.status === 200)
            {
               var result=response.data.result;
               if(result !=undefined)
               {
                
              ;
          
                }
            }
            else if(response.status === 204){
            console.log("Something wrong");
            }
            else{
            console.log("Something wrong");  
            }
            })
            .catch(function (error) {
            console.log(error);
            });
    }
    render(){
        return(
            <div className="big_div">
            <Menutest/>
            <div className="actionMenu">
            <div className="add_form">
            <MDBContainer>
              <MDBRow>
                <MDBCol md="6">
                  <MDBCard className="add_card">
                    <MDBCardBody>
                      <form onSubmit={this.handleSubmit} className="form_add_form">
                        <p className="h4 text-center py-4 text_style dark_green_color"> {i18n.t('Promotion.label')}</p>
                        <div>
                        <p className="h6 black_color">{i18n.t('type.label')}</p>
                           <Select
                          placeholder={i18n.t('select.label')}
                          fluid
                          search
                          selection
                          options={this.state.type}
                          onChange={this.onChange.bind(this)}
                          defaultValue={this.state.type}
                           />
                         <br />
                         <p className="h6 black_color">{i18n.t('description.label')}</p>
                         <TextArea rows={5} style={{ width: '100%'}} onChange={this.changeDescription}
                         defaultValue={this.state.description}/>

                      <br/> <br/> <br/>
                         <Input
                                            type="file"
                                            ref={(input) => { this.filesInput = input }}
                                            name="file"
                                            defaultValue={this.state.image}
                                            iconPosition={this.state.isArabic? 'right' :'left'}
                                            label={i18n.t('UploadIMage.label')}
                                            labelPosition={this.state.isArabic? 'left' :'right'}
                                            placeholder={i18n.t('UploadIMage.label')}
                                            onChange={this.handleChange}
                                        />
                                        
                        </div>

        
                         <div className="text-center py-4 mt-3">
                          <Button className="submit_btn_green_darked">
        
                            <MDBBtn color="cyan"  onClick={this.back}>
                            {i18n.t('Back.label')}
        
                            </MDBBtn>
                            </Button>
        
                          <Button className="submit_btn_green_darked">
                            <MDBBtn color="cyan" type="submit">
                            {i18n.t('Submit.label')}
                            </MDBBtn>
                            </Button>
                         </div>
        
                      </form>
                    </MDBCardBody>
                  </MDBCard>
                </MDBCol>
              </MDBRow>
            </MDBContainer>
            </div></div></div>
        );
    }
}
const mapStateToProps = (state)=>{
    return {...state}
  }
  export default connect(mapStateToProps) (EditPromotion);